// @noflow
import React, { Component } from 'react';

import { Bounce } from './styles';
import PropTypes from 'prop-types';

export default class BounceEffect extends Component {
    static defaultProps = {
        isWaiting: false
    };

    static propTypes = {
        children: PropTypes.node.isRequired,
        isWaiting: PropTypes.bool
    };

    state = {
        finishBounce: false
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            finishBounce: this.props.isWaiting && !nextProps.isWaiting
        });
    }

    render() {
        const { children, isWaiting, usePadding } = this.props;
        const { finishBounce } = this.state;

        return (
            <Bounce bounce={isWaiting} finishBounce={finishBounce} usePadding={usePadding}>
                {children}
            </Bounce>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/bounce-effect/index.js